
<div mat-dialog-title>View/Edit Marketing Documents<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content class="marketing-documents-dialog-container">
  @if (errorMessage) {
    <mat-card class="error block">
      <mat-card-title class="error" id="doc-link-errorMessage">{{errorMessage}}</mat-card-title>
    </mat-card>
  }
  @if (!hasAllTitles()) {
    <mat-card class="warn block">
      <mat-card-title class="warn">Please enter a document title for all files and links.</mat-card-title>
    </mat-card>
  }

  <div class="marketing-documents-help-content">
    <p>Advisors will have access to an Informa Product Report, which includes a company and model overview,
    performance metrics and other fundamentals.</p>
    <p>You can upload a combined total of 5 URLs directing advisors to more information about this
      model. To link to additional files once you've added the maximum of 5 URLs, you'll
    first need to delete one or more existing ones.</p>
    <p>Enter a link name you want to have displayed on the site. You can edit the name
      without re-uploading a link: Simply re-enter the text in the grid and click the <strong>Save</strong> button.</p>
    </div>
    <div class="marketing-documents-upload-link-container">

      <div class="marketing-documents-upload-link-container-row">
        <div class="marketing-documents-upload-link-container-element link-upload-paid-model-element">
          <div class="marketing-documents-upload-link-element-label" style="width:67px">Link</div>
          <div class="marketing-documents-upload-link-element-input">
            <irb-validation-text-box type="text" [(value)]="linkName" [width]="'100%'" max="4000"
              invalidMessage="Please enter a valid url."
              placeholder="http://www.mysite.com" [regExp]="urlRegex"
              #urlValidationTextBox
            [disabled]="disableAddDocumentLinks()"></irb-validation-text-box>
            <div class="marketing-link-url-help-text">Enter the <b>complete URL</b>&nbsp;(for example
            http://www.mysite.com or https://www.mysite.com)
          </div>
        </div>
        <!--                <div class="marketing-documents-upload-link-element-button"> <button class="btn-medium-secondary btn-spacer" (click)="onAddLink()"-->
      <!--                                                                                     [disabled]="(!urlValidationTextBox?.inputControl?.valid || disableAddDocumentLinks() || !linkName )">Add</button></div>-->
    </div>
  </div>
  <div class="marketing-documents-upload-link-container-row">
    <div class="marketing-documents-upload-link-container-element link-upload-paid-model-element">
      <div class="marketing-documents-upload-link-element-label" style="width:67px">Link Name</div>
      <div class="marketing-documents-upload-link-element-input">
        <irb-validation-text-box type="text" [(value)]="linkTitle" [width]="'100%'" max="4000"
          invalidMessage="Link name is required"
          placeholder="Link name is required"
          #urlValidationTextBox
        [disabled]="disableAddDocumentLinks()"></irb-validation-text-box>
      </div>
    </div>
  </div>
  <div class="marketing-documents-upload-link-container-row">
    <div class="marketing-documents-upload-link-element-button"> <button class="btn-medium-secondary link-add-button" (click)="onAddLink()"
    [disabled]="(!urlValidationTextBox?.inputControl?.valid || disableAddDocumentLinks() || !linkName || !linkTitle )">Add</button>
  </div>
</div>
</div>
<div class="name-your-link-documents-label"> {{getCount()}} links uploaded</div>
<irb-inventory-grid
  class="marketing-documents-links-grid-ag"
  [style.width]="'100%'"
  [gridHeight]="'240px'"
  [showSideBar]="false"
  [gridOptions]="gridOptions"
  [frameworkComponents]='frameworkComponents'
  (cellValueChanged)="onCellValueChanged($event)"
(gridReady)="onGridReady($event)"></irb-inventory-grid>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button id="saveButton" (click)="save()" class="btn-medium-primary" [disabled]="(!isModified || exceededDocumentsLinksToSave() || !hasAllTitles())">Save</button>
</mat-dialog-actions>
